module.exports = __webpack_public_path__ + "img/Icon-survey-time.7b66e1ff.svg";